import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';

import Brightness4Icon from '@material-ui/icons/Brightness4';
import Brightness7Icon from '@material-ui/icons/Brightness7';
import Tooltip from "@material-ui/core/Tooltip";

const useStyles = makeStyles((theme) => ({
    root: {
        '& > *': {
            margin: theme.spacing(1),
        },
    },
}));

export default function DashboardColorTheme(props) {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <Tooltip title="Toggle light/dark theme">
                <IconButton aria-label="toggle theme" onClick={props.toggleBeagleTheme}>
                    {props.beagleTheme === 'dark' ? (<Brightness4Icon/>) : (<Brightness7Icon/>)}
                </IconButton>
            </Tooltip>
        </div>
    );
}
